import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import {
  email,
  form,
  FormField,
  FormOptions,
  FormRoot,
  required,
  requiredError,
  SchemaPathTree,
  TreeValidationResult,
  validate,
} from '@angular/forms/signals';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { PortalType } from 'src/app/shared/model/IWebConfig';
import { PhoneNumberInputComponent } from 'src/app/shared/components/phone-number-input/phone-number-input.component';
import { FormFieldOnErrorDirective } from 'src/app/shared/directives/form-field-on-error/form-field-on-error.directive';
import { SignalFormService } from 'src/app/shared/services/signal-form/signal-form.service';
import { WINDOW } from 'src/app/shared/providers/window/window.provider';
import { RegistrationService } from '../register.service';
import { ContactStepFormModel, ContactStepSubmission } from './contact-step.model';

@Component({
  selector: 'app-register-contact-step',
  templateUrl: './contact-step.component.html',
  styleUrls: ['./contact-step.component.scss'],
  imports: [RouterLink, TranslatePipe, PhoneNumberInputComponent, FormField, FormRoot, FormFieldOnErrorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ContactStepComponent {
  #window = inject(WINDOW);
  #registrationService = inject(RegistrationService);

  public portal = input<PortalType>();
  public entityName = input<string>('');
  public termsAndConditionsUrl = input<string>('');
  public contactSubmit = output<ContactStepSubmission>();
  public back = output<void>();

  public separateDialCode = false;
  public preferredCountries: string[] = ['za', 'gb', 'us'];

  formModel = signal<ContactStepFormModel>({ email: '', mobileNumber: null, confirmCheckbox: false });
  formOptions: FormOptions<ContactStepFormModel> = SignalFormService.formSubmitOptions(this.submitContact.bind(this));
  form = form(this.formModel, this.#formValidation.bind(this), this.formOptions);

  public async submitContact(): Promise<TreeValidationResult> {
    const model = this.formModel();
    const email = model.email.toLowerCase().trim();
    const mobileNumber = model.mobileNumber?.e164Number;
    const username = email;

    const valid = await this.#registrationService.checkUniqueness(email, mobileNumber, this.entityName(), username);
    if (!valid) return undefined;

    this.contactSubmit.emit({ username, email, mobileNumber });
    return undefined;
  }

  public openTermsAndConditions(): void {
    this.#window.open(this.termsAndConditionsUrl(), '_blank');
  }

  #formValidation(path: SchemaPathTree<ContactStepFormModel>): void {
    required(path.email);
    email(path.email);
    validate(path.confirmCheckbox, (ctx) => (ctx.value() ? undefined : requiredError()));
  }
}
